import React from 'react';

import Icon from 'presentation/icons';

import {OptionIcon} from './components/OptionIcon';
import {OptionWithLink} from './components/OptionWithLink';
import {
	StyledCloseButton,
	StyledDrawerContent,
	StyledDrawerDesktopHeader,
	StyledDrawerOverlay,
	StyledDrawerTitle,
	StyledMobileHeader,
	StyledMobileHeaderButton,
	StyledOptionButton,
	StyledOptions,
	StyledSectionTitle,
} from './styles';
import {OptionsDrawerProps} from './types';

export function OptionsDrawer({isOpen, onClose, items, title}: OptionsDrawerProps) {
	return (
		<StyledDrawerOverlay anchor="right" open={isOpen} onClose={onClose}>
			<StyledMobileHeader>
				<StyledMobileHeaderButton type="button" aria-label="Voltar" onClick={onClose}>
					<Icon name="arrow-back" />
				</StyledMobileHeaderButton>
				<span>{title}</span>
			</StyledMobileHeader>

			<StyledDrawerContent>
				<StyledDrawerDesktopHeader>
					<StyledDrawerTitle id="telemedicine-drawer-title">{title}</StyledDrawerTitle>
					<StyledCloseButton
						type="button"
						aria-label={`Fechar ${title.toLowerCase()}`}
						onClick={onClose}>
						<Icon name="close-default" />
					</StyledCloseButton>
				</StyledDrawerDesktopHeader>

				<StyledSectionTitle>Selecione uma opção</StyledSectionTitle>

				<StyledOptions>
					{items.map(item => {
						if (item.link) {
							return <OptionWithLink key={item.label} {...item} />;
						}

						return (
							<StyledOptionButton
								type="button"
								key={item.label}
								onClick={item.onClick}>
								<OptionIcon icon={item.icon} imageSrc={item.imageSrc} />
								<span>{item.label}</span>
								<Icon name="arrow-right" />
							</StyledOptionButton>
						);
					})}
				</StyledOptions>
			</StyledDrawerContent>
		</StyledDrawerOverlay>
	);
}
